export default function Muted(props) {
  return (
    <svg x={0} y={0} viewBox="0 0 141.7 141.7" xmlSpace="preserve" {...props}>
      <path d="M51.5 25.3L20.8 46.7H10c-5.5 0-10 4.5-10 10v28.8c0 5.5 4.5 10 10 10h12.9l28.4 20.8c6.8 5 16.5.1 16.5-8.4V33.8c0-8.4-9.5-13.3-16.3-8.5zM127.1 44.9l-13.8 13.8-13.9-13.8c-3.3-3.3-8.8-3.3-12.1 0-3.3 3.3-3.3 8.8 0 12.1l13.8 13.8-13.8 13.9c-3.3 3.3-3.3 8.8 0 12.1 3.3 3.3 8.8 3.3 12.1 0L113.2 83 127 96.8c3.3 3.3 8.8 3.3 12.1 0 3.3-3.3 3.3-8.8 0-12.1l-13.8-13.8 13.8-13.8c3.3-3.3 3.3-8.8 0-12.1-3.3-3.4-8.7-3.4-12-.1z" />
    </svg>
  );
}
